/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { ExtendedCourse } from './ExtendedCourse';
import { UserLoginResponse } from './UserLoginResponse';
const BaseLaunchDataParser = /* #__PURE__ */ parsers.object([
    ['course', ExtendedCourse],
    ['newRoleCreated', /* #__PURE__ */ parsers.maybeNull(codecString), 'new_role_created'],
    ['newSession', /* #__PURE__ */ parsers.maybeNull(UserLoginResponse), 'new_session'],
    ['updatedEmail', /* #__PURE__ */ parsers.maybeNull(codecString), 'updated_email'],
]);
export class BaseLaunchData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseLaunchDataParser.decode(input).map(res => new BaseLaunchData(res));
    }
    static unsafeDecode(input) {
        return BaseLaunchData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseLaunchDataParser.encode(data);
    }
    static schema() {
        return BaseLaunchDataParser.schema();
    }
}
